import React, { Component } from "react";
import { connect } from "react-redux";
import { clearCart } from "../Redux/slices/cart";
import { EMPTY_CART } from "../apollo";
import { client } from "../../App";
import axios from "axios";
import PageLoading from "../Pages/PageLoading/PageLoading";
import { RegisterPurchase } from "../Pixel";

const mapStateToProps = state => {
    return {
        pluginPath: state.appSettings.pluginPath
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearCart: () => dispatch(clearCart())
    }
}

class ThankYou extends Component {
    constructor() {
        super();
        this.klarnaContainer = React.createRef();
        this.klarnaRenderScripts = this.klarnaRenderScripts.bind(this);
        this.state = {
            loading: true,
            klarnaSnippet: "",
            method: null,
            billingName: null
        }
    }

    klarnaRenderScripts() {
        var scriptsTags = this.klarnaContainer.current.getElementsByTagName("script");
        for (var i = 0; i < scriptsTags.length; i++) {
            var parentNode = scriptsTags[i].parentNode;
            var newScriptTag = document.createElement("script");
            newScriptTag.type = "text/javascript";
            newScriptTag.text = scriptsTags[i].text;
            parentNode.removeChild(scriptsTags[i]);
            parentNode.appendChild(newScriptTag);
        }
    }

    componentDidMount() {
        sessionStorage.orderSubmitted = false;

        client.mutate({
            mutation: EMPTY_CART
        }).then(() => {
            this.props.clearCart();
        }).catch(error => {
            console.error(error);
        });

        axios.get("/wp-json/vv/checkout/fetch-confirmation").then(resp => {
            if (resp.data.payment_method === "klarna") {
                this.setState({
                    klarnaSnippet: resp.data.html_snippet,
                    loading: false,
                    method: "klarna"
                });
                this.klarnaRenderScripts();

                RegisterPurchase(
                    resp.data.pixel_data.order_amount,
                    resp.data.pixel_data.currency,
                    resp.data.pixel_data.content_ids,
                    resp.data.pixel_data.order_id
                );

            } else {
                this.setState({
                    loading: false,
                    method: "international",
                    billingName: resp.data.billing_name
                });

                RegisterPurchase(
                    resp.data.pixel_data.order_amount,
                    resp.data.pixel_data.currency,
                    resp.data.pixel_data.content_ids,
                    resp.data.pixel_data.order_id
                );
            }
        }).catch(error => {
            console.error(error);
        });
    }

    render() {
        if (this.state.loading || this.state.method == null) {
            return <PageLoading />;
        }

        if (this.state.method === "klarna") {
            return <div>
                <div ref={this.klarnaContainer} dangerouslySetInnerHTML={{__html: this.state.klarnaSnippet}}></div>
            </div>
        }

        return <div className="confirmation-page">
            <img className="bag-icon" src={this.props.pluginPath + "/assets/ShoppingBag.png"} />
            <h1 className="title">Thanks{this.state.billingName === null ? "" : " " + this.state.billingName}!</h1>
            <span className="text">Your order has been placed. You will soon receive a confirmation email.</span>
        </div>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);